import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tabcontent" }
const _hoisted_2 = { class: "date3-selection" }
const _hoisted_3 = {
  class: "date3 date3-info",
  id: "date3_info_2"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// TODO: May be more efficient from the store
import 'dayjs/locale/en';
import 'dayjs/locale/he';

import { useRTL } from '@/composables/useRTL';
import { useWarDates } from '@/composables/useWarDates';

import Select from '@/components/Sidebar/Select.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Date',
  setup(__props) {

dayjs.extend(localizedFormat);
dayjs.extend(timezone);
dayjs.extend(utc);

const { t } = useI18n();

const store = useStore();
const rtl = useRTL();
const dates = computed(() => useWarDates());

const handleBackDate = () => {
  store.commit('backDate');
};

const handleNextDate = () => {
  store.commit('nextDate');
};

const formatDate = () => {
  return dayjs.tz(store.state.date, 'Asia/Jerusalem').locale(store.state.locale).format('D MMMM YYYY');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, [
      _createElementVNode("b", null, _toDisplayString(_unref(t)('dates.selection')), 1)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "info-divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('dates.move')), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["date3 move-date3s", { 'dark-mode': _unref(store).state.dark }])
      }, [
        _createElementVNode("div", {
          class: "date3 date3-change",
          title: "Go one day backwards",
          id: "change-backward",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleBackDate()))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(_unref(rtl) ? 'fas fa-chevron-right' : 'fas fa-chevron-left')
          }, null, 2)
        ]),
        _createElementVNode("h4", _hoisted_3, _toDisplayString(formatDate()), 1),
        _createElementVNode("div", {
          class: "date3 date3-change",
          title: "Go one day ahead",
          id: "change-forward",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleNextDate()))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(_unref(rtl) ? 'fas fa-chevron-left' : 'fas fa-chevron-right')
          }, null, 2)
        ])
      ], 2),
      _createVNode(Select, {
        start: dates.value.startDate,
        end: dates.value.endDate
      }, null, 8, ["start", "end"])
    ])
  ]))
}
}

})